import { render, staticRenderFns } from "./webChat.vue?vue&type=template&id=0d81a1be&scoped=true"
import script from "./webChat.vue?vue&type=script&lang=ts"
export * from "./webChat.vue?vue&type=script&lang=ts"
import style0 from "./webChat.vue?vue&type=style&index=0&id=0d81a1be&prod&lang=css"
import style1 from "./webChat.vue?vue&type=style&index=1&id=0d81a1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d81a1be",
  null
  
)

export default component.exports